import React, {useState} from "react";
import {Button} from "primereact/button";
import "../Curriculum.css";
import {Card} from "primereact/card";

/**
 * Toggle Component - Açılır/Kapanır içerik için yeniden kullanılabilir component
 * Dialog component'ine benzer API kullanır (visible/onHide)
 *
 * @example
 * // Uncontrolled kullanım (kendi state'ini yönetir)
 * <Toggle label="Form Ekle" showCard={true}>
 *   <MyForm />
 * </Toggle>
 *
 * @example
 * // Controlled kullanım (dışarıdan state yönetimi) - Dialog gibi
 * const [visible, setVisible] = useState(false);
 * <Toggle
 *   label="Form Ekle"
 *   visible={visible}
 *   onHide={() => setVisible(false)}
 *   showCard={true}
 *   cardClassName="custom-card noshadow"
 * >
 *   <MyForm />
 * </Toggle>
 *
 * @param {Object} props
 * @param {string} [props.label="Ekle"] - Açma butonunun etiketi
 * @param {string} [props.icon="pi pi-plus"] - Açma butonunun ikonu
 * @param {string} [props.closeIcon="pi pi-times"] - Kapatma butonunun ikonu
 * @param {string} [props.buttonSize="small"] - Buton boyutu
 * @param {string} [props.buttonClassName=""] - Açma butonuna eklenecek custom class
 * @param {boolean} [props.outlined=true] - Açma butonu outlined olsun mu
 * @param {string} [props.severity] - Buton renk teması (secondary, danger, vb.)
 * @param {boolean} [props.showCard=false] - İçerik Card ile sarılsın mı
 * @param {string} [props.cardClassName="noshadow"] - Card için custom class
 * @param {string} [props.containerClassName=""] - Container div için custom class
 * @param {boolean} [props.disabled=false] - Buton disabled olsun mu
 * @param {boolean} [props.visible] - Controlled mode için görünürlük durumu (Dialog gibi)
 * @param {function} [props.onHide] - Kapatma/Toggle callback'i - açma ve kapatma için kullanılır
 * @param {React.ReactNode} props.children - Toggle içeriği
 */
const Toogle = (props) => {
    const {
        label = "Ekle",
        icon = "pi pi-plus",
        closeIcon = "pi pi-times",
        buttonSize = "small",
        buttonClassName = "",
        outlined = true,
        severity,
        showCard = false,
        cardClassName = "noshadow",
        containerClassName = "",
        disabled = false,
        visible: controlledVisible,
        onHide,
        children
    } = props;

    // Internal state for uncontrolled mode
    const [internalVisible, setInternalVisible] = useState(false);

    // Determine if component is controlled or uncontrolled
    const isControlled = controlledVisible !== undefined;
    const isVisible = isControlled ? controlledVisible : internalVisible;

    const handleToggle = () => {
        if (!isControlled) {
            // Uncontrolled mode: kendi state'ini toggle et
            setInternalVisible(!isVisible);
        } else if (onHide) {
            // Controlled mode: parent'a bildir (açma/kapatma parent'ta yönetilir)
            onHide();
        }
    };

    return (
        <div className={containerClassName}>
            {!isVisible && (
                <Button
                    icon={icon}
                    label={label}
                    outlined={outlined}
                    severity={severity}
                    size={buttonSize}
                    className={buttonClassName}
                    disabled={disabled}
                    onClick={handleToggle}
                />
            )}
            {isVisible && (
                <>
                    <Button
                        icon={closeIcon}
                        rounded
                        text
                        severity="secondary"
                        aria-label="Close"
                        onClick={handleToggle}
                    />
                    {showCard ? (
                        <Card className={cardClassName}>
                            {children}
                        </Card>
                    ) : (
                        children
                    )}
                </>
            )}
        </div>
    );
};

export default Toogle;
